import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import AppContainer from './AppContainer';
import reportWebVitals from './reportWebVitals';
import cspService from './redux/authentication/utils/csp/cspService';
import securityService from './redux/authentication/utils/security/securityService';

// Import store for global access
import store from './redux/store';

// Import error debugger
import './utils/ErrorHandling/ErrorDebugging';
import './i18n';



// ===== Disable all console output in production =====
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.warn = noop;
  console.warn = noop;
}
// ====================================================


// Initialize security services
securityService.enforceHttps();
cspService.initialize();

// Make Redux store globally available for error debugging
window.__REDUX_STORE__ = store;

// Add global error handler for production
window.addEventListener('error', (event) => {
  console.warn('[Global Error Handler]', {
    message: event.error?.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    stack: event.error?.stack,
    timestamp: new Date().toISOString()
  });
});

window.addEventListener('unhandledrejection', (event) => {
  console.warn('[Unhandled Promise Rejection]', {
    reason: event.reason,
    timestamp: new Date().toISOString()
  });
});

// Create root and render app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <AppContainer />
    </HelmetProvider>
  </React.StrictMode>
);

// Report web vitals
reportWebVitals();